import { render, staticRenderFns } from "./paySuccessIntegral.vue?vue&type=template&id=35870df2&scoped=true"
import script from "./paySuccessIntegral.vue?vue&type=script&lang=js"
export * from "./paySuccessIntegral.vue?vue&type=script&lang=js"
import style0 from "./paySuccessIntegral.vue?vue&type=style&index=0&id=35870df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35870df2",
  null
  
)

export default component.exports